import { object } from "yup";

import { addressValidationSchema } from "@dzambalaorg/yup-rules-eth";
import { dbIdValidationSchema } from "@dzambalaorg/yup-rules";

export const waitlistJoinValidationSchema = object().shape({
  account: addressValidationSchema,
  listId: dbIdValidationSchema,
});
